<template>
  <DatatableReport
    v-if="config"
    ref="datatable"
    title="Batches"
    :config="config"
    :source="source"
    no-download
    :filters="filters"
  />
</template>

<script>
import { mapActions, mapState } from "vuex";

import BatchedActionsContextMenu from "@/Reports/BatchedActionsContextMenu.vue";
import DatatableReport from "@/Reports/DatatableReportV3.vue";
import store from "../vuex/store";

export default {
  components: {
    DatatableReport
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: null
    };
  },
  computed: {
    ...mapState(["tenant", "fetchingTenant"])
  },
  watch: {
    tenant(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setConfig();
      }
    }
  },
  mounted() {
    if (!this.tenant && !this.fetchingTenant) {
      this.fetchTenant();
    }
    if (this.tenant) {
      this.setConfig();
    }
    this.$store.dispatch("addBreadcrumb", { label: "Batches" });
  },
  methods: {
    ...mapActions(["fetchTenant"]),
    setConfig() {
      this.config = {
        order: [[0, "desc"]],
        columns: this.getColumns(),
        vueComponents: [
          {
            rootId: "batched-actions-context-menu-vue",
            component: BatchedActionsContextMenu,
            options: {
              store,
              listeners: { "refresh-datatable": this.refreshData }
            }
          }
        ]
      };
    },
    refreshData() {
      this.$refs.datatable.refreshData();
    },
    getColumns() {
      const columns = [
        { data: "exported_at", title: "Exported At", searchable: false },
        { data: "batch_number", title: "Batch #" },
        { data: "created_by", title: "Created By" },
        {
          data: "invoices",
          orderable: false,
          className: "text-center",
          searchable: false
        },
        {
          data: "invoices_total",
          title: "Invoices Total",
          className: "text-right",
          searchable: false
        },
        {
          data: "payments",
          orderable: false,
          className: "text-center",
          searchable: false
        },
        {
          data: "payments_total",
          title: "Payments Total",
          className: "text-right",
          searchable: false
        }
      ];

      if (this.tenant.feature_flags.enable_break_batch) {
        return [
          ...columns.slice(0, 2),
          { data: "batch_name" },
          ...columns.slice(2),
          { data: "actions", title: "", searchable: false }
        ];
      } else {
        return [
          ...columns,
          { data: "download", title: "Download Batch", searchable: false }
        ];
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
